import type { PostProcessorModule } from 'i18next'
import { PSEUDO_LOCALE } from './languages'

/**
 * The `en-XA` pseudo-locale, for development only. Every string is accented and padded to about
 * 135% of its length, so untranslated copy (plain ASCII) and layouts that cannot take longer
 * languages (German, French) both show before real translations exist.
 */

const PLAIN = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
const ACCENTED = Array.from('áƀçðéƒĝĥíĵķļɱñóþǫŕšţûṽŵẋýžÁƁÇÐÉƑĜĤÍĴĶĻṀÑÓÞǪŔŠŢÛṼŴẊÝŽ')

const PADDING = ' ļóŕéɱ íþšûɱ ðóļóŕ šíţ áɱéţ'

// Tags (<0>, <strong>), leftover placeholders ({name}, {{name}}) and HTML entities stay as they are,
// so <Trans> components and interpolation keep working.
const PROTECTED = /(<[^>]*>|\{\{[^}]*\}\}|\{[^}]*\}|&[a-zA-Z#0-9]+;)/

export const pseudoLocalize = (input: string): string => {
  if (!input) return input
  const parts = input.split(PROTECTED)
  let visibleLength = 0
  const accented = parts
    .map((part, index) => {
      if (index % 2 === 1) return part
      visibleLength += part.length
      return part.replace(/[a-zA-Z]/g, (letter) => ACCENTED[PLAIN.indexOf(letter)] || letter)
    })
    .join('')
  const extra = Math.ceil(visibleLength * 0.35)
  let padding = ''
  while (padding.length < extra) padding += PADDING
  return `[${accented}${padding.slice(0, extra)}]`
}

export const pseudoPostProcessor: PostProcessorModule = {
  type: 'postProcessor',
  name: 'pseudo',
  process(value: string, _key: string | string[], options: any, translator: any) {
    const language = options?.lng || translator?.language
    return language === PSEUDO_LOCALE && typeof value === 'string' ? pseudoLocalize(value) : value
  },
}
